import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialogConfig, MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { LoadingService } from '../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/_services/notification.service';
import { DeliveryVehicleService } from '../_ecomservices/delivery-vehicle.service';
import { OrderEditComponent } from '../order-edit/order-edit.component';

@Component({
  selector: 'app-delivery-process',
  templateUrl: './delivery-process.component.html',
  styleUrls: ['./delivery-process.component.css']
})
export class DeliveryProcessComponent implements OnInit {

  displayedColumns: string[] = ['select', 'SlNo', 'bill_no', 'AssignmentDate', 'CustomerName',  'Mobile', 
    'BillAmount'];
   
   totalCrate:number = 0;
   orderSelection = new SelectionModel<any>(true, []);  
   deliveryVehicleList= [];
   selecteddeliveryVehicle:number = 0;
   orderStatusList:number = 0;
   selectedOrderStatus:number = 0;
   
   dataSource: MatTableDataSource<any>;
   searchKey: string;
 
   order_status_form = new FormGroup({
     id : new FormControl(null),
     order_status : new FormControl('', [Validators.required]),
     shipping_status : new FormControl(''),
     created_at : new FormControl(''),
   });
 
   constructor(
   private titleService: Title,
   private dialog: MatDialog,
   public orderService: OrderService,
   private loading : LoadingService,
   private deliveryVehicleService:DeliveryVehicleService,
   public datePipe: DatePipe,
   private notificationService: NotificationService,
   private route: ActivatedRoute,) { }
 
 
   ngOnInit() {
     this.titleService.setTitle('Order List');
     this.onLoadVehicles();
   }

   onLoadVehicles() {
    var result = this.deliveryVehicleService.delivery_active_vehicles().subscribe(data=> {
      this.deliveryVehicleList = data['vehicles'];
    });
  }

   onChangeVehicle(){
     let vehDetails = this.deliveryVehicleList.find(x=> x.id === this.selecteddeliveryVehicle);
     if(vehDetails){
      this.onLoadOrders();
     }
   }
 
   onLoadOrders() {
    console.log(this.selecteddeliveryVehicle);
    // this.loading.spin$.next(true);
     var result = this.orderService.get_bill_generated_orders(this.selecteddeliveryVehicle).subscribe(data=> {
       this.dataSource = new MatTableDataSource<any>(data['orders']);
       this.orderStatusList = data['next_status_list'];
       this.loading.spin$.next(false);
     });
   }

  onEditOrder(order_id) 
  {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "99%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { order_id: order_id, isEditItemOnly: true };
    this.dialog.open(OrderEditComponent, matDialogConfig).afterClosed().subscribe(res=>{
      // console.log(res);
      this.onLoadOrders();
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllOrderSelected() {
    const numSelected = this.orderSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllOrderSelected() ?
    this.orderSelection.clear() :
    this.dataSource.data.forEach(row => this.orderSelection.select(row));
    // this.totalCrate = 0;
    // this.orderSelection.selected.forEach(element => {
    //   this.totalCrate += element.total_crate;
    // });
    // console.log(this.totalCrate);
  }

  onGenerateOrderBills(){
    if (this.orderSelection.selected.length > 0){
      if(this.selecteddeliveryVehicle <= 0){
        this.notificationService.warn('Please selecte delivery vehicle');
      }
      else if(this.selectedOrderStatus <= 0){
        this.notificationService.warn('Please selecte order status');
      }
      else
      {
        this.loading.spin$.next(true);
        this.orderService.update_out_of_delivery(this.orderSelection.selected, this.selectedOrderStatus).subscribe(data=>{          
          if (data['status']) 
          {
            this.orderSelection.clear();
            this.totalCrate = 0;
            // this.selecteddeliveryVehicle = 0;
            this.selectedOrderStatus = 0;
            this.onLoadOrders();
            this.notificationService.success(data['message']);
            this.loading.spin$.next(false);
          } 
          else
          {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
    else{
      this.notificationService.warn('Please selecte order for asign to delivery');
    }
  }

 
 }
 